import { GenIcon } from '../helpers/IconBase.es.js';

const CubeOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_16327_633)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M13.6847 2.81128L9.66668 0.491275C9.15962 0.199689 8.58494 0.0462341 8.00002 0.0462341C7.41509 0.0462341 6.84041 0.199689 6.33335 0.491275L2.31535 2.81128C1.80926 3.10455 1.389 3.52549 1.09653 4.03204C0.804064 4.53859 0.649639 5.11302 0.648682 5.69794V10.3379C0.649657 10.9229 0.804083 11.4975 1.09654 12.0041C1.389 12.5108 1.80926 12.9318 2.31535 13.2253L6.33335 15.5446C6.84034 15.8364 7.41505 15.99 8.00002 15.99C8.58498 15.99 9.15969 15.8364 9.66668 15.5446L13.6847 13.2253C14.1908 12.9318 14.611 12.5108 14.9035 12.0041C15.1959 11.4975 15.3504 10.9229 15.3513 10.3379V5.69794C15.3504 5.11302 15.196 4.53859 14.9035 4.03204C14.611 3.52549 14.1908 3.10455 13.6847 2.81128ZM7.00002 1.64661C7.30405 1.47107 7.64894 1.37866 8.00002 1.37866C8.35109 1.37866 8.69598 1.47107 9.00002 1.64661L13.018 3.96594C13.1199 4.03034 13.2156 4.10398 13.304 4.18594L9.17535 6.56927C8.81791 6.77533 8.41259 6.88379 8.00002 6.88379C7.58744 6.88379 7.18212 6.77533 6.82468 6.56927L2.69602 4.18594C2.78439 4.10398 2.88013 4.03034 2.98202 3.96594L7.00002 1.64661ZM2.98202 12.0699C2.67815 11.8939 2.42585 11.6411 2.25036 11.3369C2.07486 11.0327 1.98233 10.6878 1.98202 10.3366V5.69794C1.98664 5.57784 2.00249 5.45843 2.02935 5.34128L6.15802 7.72461C6.52264 7.93202 6.92021 8.07522 7.33335 8.14794V14.5273C7.21819 14.492 7.10659 14.446 7.00002 14.3899L2.98202 12.0699ZM14.018 10.3366C14.0177 10.6878 13.9252 11.0327 13.7497 11.3369C13.5742 11.6411 13.3219 11.8939 13.018 12.0699L9.00002 14.3899C8.89344 14.446 8.78184 14.492 8.66668 14.5273V8.14794C9.07982 8.07522 9.47739 7.93202 9.84202 7.72461L13.9707 5.34128C13.9975 5.45843 14.0134 5.57784 14.018 5.69794V10.3366Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_16327_633" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { CubeOutlined };
